
import theme from "./theme/theme.js";
import Quiz from "./pages/Quiz";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Result from "./pages/Result";
import Name from "./pages/Name";
import {CssBaseline, ThemeProvider} from "@mui/material";

const router = createBrowserRouter([
    { path: '/nome', element: <Name/>},
    { path: '/result', element: <Result/>},
    { path: '/', element: <Quiz/>}
])


function App() {
  return (
      <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
      </ThemeProvider>
  )
}

export default App;
